import React from "react";

//components
import Icon from "../../icons/Icon";
import ProfileImage from "../../images/profileImages/ProfileImage";

//helpers
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import { IContentPostInformation } from '../../../../interfaces/information/ContentPostInformation';



const ContentPostInformation = ({className, profileImageUrl, authorName, authorJobInformation, date, accessToken}: IContentPostInformation) => {

    return (
        <div className={`content-post-information-wrapper ${className}`} >
            <div className="left-panel">
                <ProfileImage 
                    profileImageUrl={profileImageUrl} 
                    accessToken={accessToken} 
                    isSquareImage
                />
            </div>

            <div className="right-panel">
                <span className="author-name">
                    {authorName}
                </span>

                {authorJobInformation &&
                    <span className="author-job-information">
                        <Icon 
                            iconName={IconLibrary.BRIEFCASE} 
                            sizeInPx="12" 
                            className="content-post-information-icon" 
                            color="var(--thriveGreyDark)"
                        />
                        
                        {authorJobInformation}
                    </span>
                }

                {date &&
                    <span className="content-post-time">
                        <Icon iconName={IconLibrary.CLOCK}
                            sizeInPx="12" 
                            className="content-post-information-icon" 
                            color="var(--thriveGreyDark)"
                        />
                    
                        {date}
                    </span>
                }
            </div>
           
        </div>
    );
};

export default ContentPostInformation